import { ScreenSize } from 'glints-aries';
import { DropShadow } from 'glints-aries/lib/@next';
import {
  borderRadius8,
  borderRadius16,
} from 'glints-aries/lib/@next/utilities/borderRadius';
import { Blue, Neutral } from 'glints-aries/lib/@next/utilities/colors';
import styled from 'styled-components';

import {
  CARD_SHADOW_HOVER,
  MOBILE_BREAKPOINT,
  SGGradients,
} from '../constants';

export { SGInner as Inner } from './shared.sc';

export const Section = styled.section`
  padding: 64px 0;
  background: ${Neutral.B99};

  @media (max-width: ${ScreenSize.tablet}px) {
    padding: 48px 0;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 36px 0;
  }
`;

export const Head = styled.div`
  text-align: center;
  margin-bottom: 40px;

  @media (max-width: ${ScreenSize.tablet}px) {
    margin-bottom: 28px;
  }
`;

export const Eyebrow = styled.span`
  display: inline-block;
  color: ${Blue.S99};
  font-weight: 700;
  font-size: 12.5px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  margin-bottom: 8px;
  background: ${Neutral.B100};
  padding: 6px 14px;
  border-radius: 999px;
`;

export const Title = styled.h2`
  font-size: 32px;
  margin: 0;
  color: ${Neutral.B18};
  letter-spacing: -0.015em;

  @media (max-width: ${ScreenSize.tablet}px) {
    font-size: 24px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 20px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: ${ScreenSize.tablet}px) {
    grid-template-columns: 1fr 1fr;
    gap: 14px;
  }
`;

export const CardWrapper = styled.div`
  position: relative;

  @media (max-width: ${ScreenSize.tablet}px) {
    &:last-child:nth-child(odd) {
      grid-column: 1 / -1;
    }
  }
`;

export const Card = styled.div`
  position: relative;
  background: ${Neutral.B100};
  border: thin solid ${Neutral.B85};
  border-radius: ${borderRadius16};
  box-shadow: ${DropShadow.card};
  padding: 28px 24px;
  text-align: center;
  overflow: hidden;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;

  @media (max-width: ${ScreenSize.tablet}px) {
    padding: 22px 16px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 18px 12px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: ${SGGradients.blue};
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.25s ease;
  }

  ${CardWrapper}:hover & {
    transform: translateY(-4px);
    box-shadow: ${CARD_SHADOW_HOVER};
    border-color: ${Blue.S54};
  }

  ${CardWrapper}:hover &::before,
  ${CardWrapper}:focus-within &::before {
    transform: scaleX(1);
  }

  &:focus-visible {
    outline: 2px solid ${Blue.S99};
    outline-offset: 4px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition:
      box-shadow 0.2s ease,
      border-color 0.2s ease;

    ${CardWrapper}:hover & {
      transform: none;
    }
  }
`;

export const IconWrap = styled.div`
  width: 48px;
  height: 48px;
  border-radius: ${borderRadius8};
  margin: 0 auto 14px;
  background: ${Neutral.B99};
  color: ${Blue.S99};
  display: grid;
  place-items: center;

  svg {
    width: 22px;
    height: 22px;
    fill: currentColor;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const Number = styled.div`
  font-size: 40px;
  font-weight: 700;
  color: ${Neutral.B18};
  letter-spacing: -0.025em;
  line-height: 1;
  font-variant-numeric: tabular-nums;

  @media (max-width: ${ScreenSize.tablet}px) {
    font-size: 32px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 28px;
  }
`;

export const Plus = styled.span`
  color: ${Blue.Brand};
`;

export const Label = styled.div`
  color: ${Neutral.B40};
  font-size: 14px;
  margin-top: 6px;
  line-height: 1.4;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 12.5px;
  }
`;
